import {
  BaSeBox,
  BaSeContainer,
  BaSeGrid,
  BaSeGridItem,
  BaSeInput,
  BaSeParagraph,
  BaSeSmall1,
  BaSeTabs,
  BaSeTextArea,
  BaSeTheme,
  BaSeToggler,
} from '@base/react';
import React from 'react';
import {
  ContentCodeHtml,
  Divisor,
  InputCodeHtml,
  WrapperNotFound,
  WrapperThemeInput,
} from './template-certificados-styled';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { ReactComponent as NotFoundVariables } from '../../assets/not-found-data.svg';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/moxer.css';
import 'codemirror/theme/neo.css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import NotFoundComponent from '../not-found-components/not-found';

import ViewTemplate from './view-template';

const PageTemplate = ({
  setPageTemplate,
  pageTemplate,
  dtoTemplate,
  setIsClear,
  isClear,
  isFillFields,
  typeAction,
  isModelPrint,
}) => {
  const [activatedTabIndex, setActivatedTabIndex] = React.useState(0);
  const [codeHtml, setCodeHtml] = React.useState('');
  const [codeHtmlForPrint, setCodeHtmlForPrint] = React.useState('');
  const [variables, setVariables] = React.useState([]);
  const [isThemeLigth, setIsThemeLigth] = React.useState(true);
  const [isTabViewActive, setIsTabViewActive] = React.useState(false);
  const [textValidation, setTextValidation] = React.useState('');
  const [textWhatsappEmail, setTextWhatsappEmail] = React.useState('');
  const [isUpdateVariables, setIsUpdatesVariable] =
    React.useState(isFillFields);

  const { white } = BaSeTheme.colors.defaultColors;
  const { azulSebrae36, cinzaSebrae45, cinzaSebrae90 } =
    BaSeTheme.colors.institucionais;

  const ThemesOptions = () => {
    return (
      <WrapperThemeInput>
        <BaSeParagraph isItalic color={cinzaSebrae45}>
          {`Tema ${isThemeLigth ? 'claro' : 'escuro'}`}
        </BaSeParagraph>
        <BaSeToggler
          color="default"
          onChange={() => {
            setIsThemeLigth((theme) => !theme);
          }}
          type="outlined"
          value={isThemeLigth}
        />
      </WrapperThemeInput>
    );
  };

  const options = React.useMemo(
    () => ({
      mode: 'htmlmixed',
      theme: isThemeLigth ? 'neo' : 'moxer',
      lineNumbers: true,
      readOnly: typeAction === 'show',
    }),
    [isThemeLigth, typeAction],
  );

  const sizeEditor = React.useCallback((editor) => {
    const sizeEditor = editor.doc.height < 300 ? 330 : editor.doc.height + 30;
    editor.setSize(null, sizeEditor);
  }, []);

  const code = React.useCallback(() => {
    setIsTabViewActive(false);
    return (
      <ContentCodeHtml>
        <ThemesOptions />
        <BaSeContainer delimitedOnBreakpoint="desktop">
          <InputCodeHtml>
            <CodeMirror
              value={codeHtml}
              options={options}
              onCursorActivity={(editor) => sizeEditor(editor)}
              onBeforeChange={(editor, data, value) => {
                setIsUpdatesVariable(false);
                setCodeHtml(value);
              }}
              onChange={(editor, data, value) => {
                sizeEditor(editor);
                setPageTemplate((currentPage) => {
                  currentPage.codeHtml = value;
                  return currentPage;
                });
              }}
            />
          </InputCodeHtml>
        </BaSeContainer>
      </ContentCodeHtml>
    );
  }, [codeHtml, options, setPageTemplate, sizeEditor]);

  const codeForPrint = React.useCallback(
    () => (
      <ContentCodeHtml>
        <ThemesOptions />
        <BaSeContainer delimitedOnBreakpoint="desktop">
          <InputCodeHtml>
            <CodeMirror
              value={codeHtmlForPrint}
              options={options}
              onCursorActivity={(editor) => sizeEditor(editor)}
              onBeforeChange={(editor, data, value) => {
                setCodeHtmlForPrint(value);
              }}
              onChange={(editor, data, value) => {
                sizeEditor(editor);
                setPageTemplate((currentPage) => {
                  currentPage.codeHtmlPrint = value;
                  return currentPage;
                });
              }}
            />
          </InputCodeHtml>
        </BaSeContainer>
      </ContentCodeHtml>
    ),
    [codeHtmlForPrint, options, setPageTemplate, sizeEditor],
  );

  const ignoreVariables = React.useMemo(
    () => ['QRCODE', 'IDCERTIFICADO', 'URLVALIDACAO', 'CPFFORMATADO'],
    [],
  );

  const inputVariables = React.useCallback(
    (text) => {
      const regex = /\$\{([a-zA-Z0-9_]+)\}(?<!\w)/g;
      const result = [];
      let match;

      while ((match = regex.exec(text))) {
        const ignoreValue = ignoreVariables.includes(match[1]);
        if (!ignoreValue) result.push(match[1]);
      }

      return [...new Set(result)];
    },
    [ignoreVariables],
  );

  const handleChangeInputVariables = React.useCallback(
    (value, i) => {
      setVariables((currentInputs) => {
        currentInputs[i].valor = value;
        setPageTemplate((currentPage) => {
          currentPage.variables = [...currentInputs];
          return currentPage;
        });
        return [...currentInputs];
      });
    },
    [setPageTemplate],
  );

  const codeHtmlPrint = React.useMemo(() => {
    const codeHtmlNotPrint = [
      {
        content: () => {
          setIsTabViewActive(false);
          return !!variables.length ? (
            <>
              <div style={{ margin: '30px 20px 20px' }}>
                <BaSeGrid>
                  <BaSeGridItem size={3}>
                    <BaSeSmall1 color={cinzaSebrae45} isBold>
                      Variável disponível
                    </BaSeSmall1>
                  </BaSeGridItem>
                  <BaSeGridItem size={9}>
                    <BaSeSmall1 color={cinzaSebrae45} isBold>
                      Exemplo de preenchimento
                    </BaSeSmall1>
                  </BaSeGridItem>
                </BaSeGrid>
              </div>
              <Divisor />
              {variables.map((label, i) => (
                <React.Fragment key={i}>
                  <div style={{ margin: '10px 20px auto' }}>
                    <BaSeGrid>
                      <BaSeGridItem size={3}>
                        <BaSeParagraph isBold>{label.chave}</BaSeParagraph>
                      </BaSeGridItem>
                      <BaSeGridItem size={9}>
                        <BaSeInput
                          isDisabled={typeAction === 'show'}
                          onChange={(e) => handleChangeInputVariables(e, i)}
                          placeholder={`Digite um exemplo para a variável ${label.chave}`}
                          value={variables[i].valor}
                        />
                      </BaSeGridItem>
                    </BaSeGrid>
                  </div>
                  <Divisor />
                </React.Fragment>
              ))}
            </>
          ) : (
            <WrapperNotFound>
              <NotFoundComponent
                title="Nenhuma variável encontrada"
                subtitle="Verifique se o Código HTML utiliza variáveis no formato $nomeDaVariável"
                color={cinzaSebrae45}
              >
                <NotFoundVariables />
              </NotFoundComponent>
            </WrapperNotFound>
          );
        },
        isDisabled: false,
        title: {
          iconDescription: 'Ícone de não iniciado',
          label: 'Variáveis',
        },
      },
      {
        content: () => (
          <ViewTemplate
            variables={variables}
            dtoTemplate={dtoTemplate}
            codeHtml={codeHtml}
            isTabActive={isTabViewActive}
            setIsTabActive={setIsTabViewActive}
          />
        ),
        title: {
          iconDescription: 'Ícone de concluído',
          label: 'Visualizar PDF',
        },
      },
      {
        content: () => (
          <div style={{ marginTop: 20 }}>
            <BaSeTextArea
              isDisabled={typeAction === 'show'}
              onChange={(e) => {
                setTextValidation(e);
                setPageTemplate((currentPage) => {
                  currentPage.textValidation = e;
                  return currentPage;
                });
              }}
              rows={14}
              textSize="medium"
              value={textValidation}
            />
          </div>
        ),

        title: {
          iconDescription: 'Ícone padrão validador',
          label: 'Padrão validador',
        },
      },
      {
        content: () => (
          <div style={{ marginTop: 20 }}>
            <BaSeTextArea
              isDisabled={typeAction === 'show'}
              onChange={(e) => {
                setTextWhatsappEmail(e);
                setPageTemplate((currentPage) => {
                  currentPage.textoWhatsappAndEmail = e;
                  return currentPage;
                });
              }}
              rows={14}
              textSize="medium"
              value={textWhatsappEmail}
            />
          </div>
        ),
        inactiveColor: cinzaSebrae90,
        title: {
          label: 'Texto Whatsapp e Email',
        },
      },
    ];

    const codePrint = {
      content: () => codeForPrint(),
      isDisabled: !isModelPrint,
      inactiveColor: cinzaSebrae90,
      title: {
        iconDescription: 'Configurações',
        label: 'Código HTML para impressão',
      },
    };

    return isModelPrint ? [...codeHtmlNotPrint, codePrint] : codeHtmlNotPrint;
  }, [
    cinzaSebrae45,
    cinzaSebrae90,
    codeForPrint,
    codeHtml,
    dtoTemplate,
    handleChangeInputVariables,
    isModelPrint,
    isTabViewActive,
    setPageTemplate,
    textValidation,
    textWhatsappEmail,
    typeAction,
    variables,
  ]);

  const hiddenTabs = React.useCallback(
    (indexTab) => {
      if (indexTab === 5 && !isModelPrint) {
        return 4;
      }
      return indexTab;
    },
    [isModelPrint],
  );

  React.useEffect(() => {
    if (isClear) {
      setCodeHtml('');
      setCodeHtmlForPrint('');
      setTextValidation('');
      setIsClear(false);
    }
  }, [isClear, setIsClear]);

  React.useEffect(() => {
    const values = inputVariables(codeHtml);

    setVariables(() => {
      if (!!values.length) {
        const listInput = values.map((item) => ({ chave: item, valor: '' }));
        return isUpdateVariables ? pageTemplate?.variables : listInput;
      }
      return [];
    });
  }, [codeHtml, inputVariables, isUpdateVariables, pageTemplate]);

  // eslint-disable-next-line sonarjs/cognitive-complexity
  React.useEffect(() => {
    if (isFillFields) {
      setCodeHtml(pageTemplate?.codeHtml ?? '');
      setVariables(pageTemplate?.variables ?? []);
      setCodeHtmlForPrint(pageTemplate?.codeHtmlPrint ?? '');
      setTextValidation(pageTemplate?.textValidation ?? '');
      setTextWhatsappEmail(pageTemplate?.textoWhatsappAndEmail ?? '');
    }
  }, [isFillFields, pageTemplate]);

  return (
    <>
      <BaSeBox
        backgroundColor={white}
        borderColor={cinzaSebrae90}
        elevationOnHoverOrFocus={false}
        renderContent={() => (
          <div>
            <BaSeTabs
              activatedTabIndex={hiddenTabs(activatedTabIndex)}
              activeColor={azulSebrae36}
              inactiveColor={cinzaSebrae45}
              onActivatedTabIndex={(tab) =>
                setActivatedTabIndex(hiddenTabs(tab))
              }
              tabGap={24}
              tabs={[
                {
                  content: () => code(),
                  title: {
                    iconDescription: 'Configurações',
                    label: 'Código HTML',
                  },
                },
                ...codeHtmlPrint,
              ]}
            />
          </div>
        )}
        shadowLevel={2}
      />
    </>
  );
};

export { PageTemplate as default };
